import {Component, HostListener, Injector, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {BaseComponents} from '../../shared/base-components';
import {TYPE_META} from '../../core/constants/meta_title.constant';

@Component({
    selector: 'app-a-montreal',
    templateUrl: './a-montreal.component.html',
    styleUrls: ['./a-montreal.component.sass']
})
export class AmontrealComponent extends BaseComponents implements OnInit {
    constructor(
        protected injector: Injector,
        protected titleService: Title,
        protected meta: Meta) {
        super(injector);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleMobile();
    }

    ngOnInit() {
        super.ngOnInit();
        this.setMetaTitle(TYPE_META.A_MONTREAL);
    }
}
